import { ReactNode } from "react";
import { matchPath, useLocation } from "react-router-dom";

import { MobileNavbarItem, PageWithBottomNavbar } from "@seneca/senekit";

import { linkToDashboard } from "features/dashboard/links";
import { linkToStudentClasses } from "features/dashboard/pages/classes/links";
import { linkToCoursesPage } from "features/dashboard/pages/courses-page/links";
import { linkToMorePage } from "features/dashboard/pages/more-page/links";
import {
  makeLinkToWhatIsPremium,
  SUBSCRIPTION_JOURNEY_SOURCES
} from "features/dashboard/pages/what-is-premium-page/routes/links";
import { isNativeAppiOS } from "features/pwa/mobile/ios/utils/isNativeAppiOS";

import {
  locationIncludesAssignmentsRoute,
  locationIncludesDashboardRoute,
  locationIncludesMoreRoute
} from "../utils/locationIncludesRoute";
import { NavbarProps } from "./DashboardNavbar";

export default function MobileNavbar({
  children,
  sellPremiumToUser,
  sellUpgradeToUser,
  isTeacher,
  isPlurallApp,
  linkToWhatIsPremium
}: NavbarProps & { children: ReactNode }) {
  const location = useLocation();
  const isiOSApp = isNativeAppiOS();

  const showPremiumItem =
    (sellPremiumToUser || sellUpgradeToUser) && !isPlurallApp && !isTeacher;
  const premiumLabel = sellUpgradeToUser ? "Upgrade" : "Premium";

  const NavbarItems = [
    <MobileNavbarItem
      label="Home"
      to={linkToDashboard()}
      isActive={locationIncludesDashboardRoute({
        location
      })}
      iconName="house"
    />,

    <MobileNavbarItem
      label="Courses"
      to={linkToCoursesPage()}
      isActive={location.pathname.includes(linkToCoursesPage())}
      iconName="book"
    />,

    <MobileNavbarItem
      label="Assignments"
      to={linkToStudentClasses()}
      isActive={locationIncludesAssignmentsRoute({
        location
      })}
      iconName="notePencil"
    />,

    ...(showPremiumItem
      ? [
          <MobileNavbarItem
            label={premiumLabel}
            to={linkToWhatIsPremium}
            isActive={
              !!matchPath(location.pathname, {
                path: linkToWhatIsPremiumPage().pathname
              })
            }
            iconName="rocket"
          />
        ]
      : []),

    <MobileNavbarItem
      label="More"
      to={linkToMorePage()}
      isActive={locationIncludesMoreRoute(location)}
      iconName="more"
    />
  ];

  return (
    <PageWithBottomNavbar isiOSApp={isiOSApp}>
      {{
        page: children,
        navbarItems: NavbarItems
      }}
    </PageWithBottomNavbar>
  );
}

function linkToWhatIsPremiumPage() {
  return makeLinkToWhatIsPremium({
    source: SUBSCRIPTION_JOURNEY_SOURCES.DASHBOARD_NAVBAR
  });
}
